import React, { Component } from 'react'
import moment from 'moment'
import FormattedMessage from '../FormattedMessage/FormattedMessage'

export default class ActivationKeyExpiration extends Component {
  render() {
    const { expiryDate } = this.props
    const m = moment(expiryDate)
    const formattedDate = m.isValid() ? m.format('YYYY-MM-DD') : 'TBD'

    return (
      <div role="status" aria-live="polite">
        <p className="header mt-3" aria-label={`Activation key expires on ${formattedDate}`}>
          <FormattedMessage
            id="global.label.activationExpiration"
            values={{
              date: formattedDate,
            }}
          />
        </p>
      </div>
    )
  }
}
